function getLineHeight (el) {
    var temp = document.createElement(el.nodeName), ret;
    temp.setAttribute('style', 'margin:0; padding:0; '
        + 'font-family:' + (el.style.fontFamily || 'inherit') + '; '
        + 'font-size:' + (el.style.fontSize || 'inherit'));
    temp.innerHTML = 'A';

    el.parentNode.appendChild(temp);
    ret = temp.clientHeight;
    temp.parentNode.removeChild(temp);

    return ret;
}

/**
 * show
 *
 * @param elem
 * @param displayState
 *
 * @description Show element.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const show = function (elem, displayState = 'block') {
    elem.style.display = displayState;
};

/**
 * hide
 *
 * @param elem
 *
 * @description Hide element.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const hide = function (elem) {
    elem.style.display = 'none';
};

/**
 * toggle
 *
 * @param elem
 * @param showDisplayState
 *
 * @description Toggle show/hide element.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const toggle = function (elem, showDisplayState = 'block') {
    if (window.getComputedStyle(elem).display === 'none') {
        // show element
        show(elem, showDisplayState);
    } else {
        // hide element
        hide(elem);
    }
};

/**
 * slideUp
 *
 * @param target
 * @param duration
 * @param easing
 * @param cb
 *
 * @description Slide up animation.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const slideUp = (target, duration = 500, easing = 'ease', cb = () => {
}) => {
    // set height
    const computed = getComputedStyle(target);
    let height = 0;
    if (computed.boxSizing === 'border-box') {
        height = target.offsetHeight + 'px';
    } else {
        const pt = parseFloat(computed.paddingTop);
        const pb = parseFloat(computed.paddingBottom);
        const bt = parseFloat(computed.borderTopWidth);
        const bb = parseFloat(computed.borderBottomWidth);
        height = target.offsetHeight - pt - pb - bt - bb + 'px';
    }
    // set overflow
    target.style.overflow = 'hidden';
    target.style.height = height;

    // set css3 transitions
    window.setTimeout(() => {
        target.style.transitionProperty = 'height, margin, padding, border, line-height';
        target.style.transitionDuration = duration + 'ms';
        target.style.transitionTimingFunction = easing;
        // set styling for animation
        window.setTimeout(() => {
            target.style.height = 0;
            target.style.paddingTop = 0;
            target.style.paddingBottom = 0;
            target.style.marginTop = 0;
            target.style.marginBottom = 0;
            target.style.borderTop = 0;
            target.style.borderBottom = 0;
            target.style.lineHeight = 0;

            // remove styling after duration
            window.setTimeout(() => {
                target.style.display = 'none';
                target.style.removeProperty('height');
                target.style.removeProperty('padding-top');
                target.style.removeProperty('padding-bottom');
                target.style.removeProperty('margin-top');
                target.style.removeProperty('margin-bottom');
                target.style.removeProperty('border-top-width');
                target.style.removeProperty('border-bottom-width');
                target.style.removeProperty('line-height');
                target.style.removeProperty('overflow');
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
                target.style.removeProperty('transition-timing-function');

                // trigger optional callback function
                cb();
            }, duration);
        }, 5);
    }, 5);
};

/**
 * slideDown
 *
 * @param target
 * @param duration
 * @param easing
 * @param cb
 *
 * @description Slide down animation.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const slideDown = (target, duration = 500, easing = 'ease', cb = () => {
}) => {
    const computed = window.getComputedStyle(target);
    target.style.removeProperty('display');
    let display = computed.display;
    if (display === 'none') {
        display = 'block';
    }
    target.style.display = display;
    let height = 0;
    const pt = parseFloat(computed.paddingTop);
    const pb = parseFloat(computed.paddingBottom);
    const mt = parseFloat(computed.marginTop);
    const mb = parseFloat(computed.marginBottom);
    const bt = parseFloat(computed.borderTopWidth);
    const bb = parseFloat(computed.borderBottomWidth);
    const lh = getLineHeight(target) / parseFloat(computed.fontSize);

    if (computed.boxSizing === 'border-box') {
        height = target.offsetHeight;
    } else {
        height = target.offsetHeight - pt - pb - bt - bb;
    }
    target.style.overflow = 'hidden';
    // set init styling
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.style.borderTopWidth = 0;
    target.style.borderBottomWidth = 0;
    target.style.lineHeight = 0;
    // set css3 transitions
    window.setTimeout(() => {
        target.style.transitionProperty = 'height, margin, padding, border, line-height';
        target.style.transitionDuration = duration + 'ms';
        target.style.transitionTimingFunction = easing;
        // set styling for animation
        window.setTimeout(() => {
            target.style.height = height + 'px';
            target.style.paddingTop = pt + 'px';
            target.style.paddingBottom = pb + 'px';
            target.style.marginTop = mt + 'px';
            target.style.marginBottom = mb + 'px';
            target.style.borderTopWidth = bt + 'px';
            target.style.borderBottomWidth = bb + 'px';
            target.style.lineHeight = lh;
            // remove styling after duration
            window.setTimeout(() => {
                target.style.removeProperty('height');
                target.style.removeProperty('transition-duration');
                target.style.removeProperty('transition-property');
                target.style.removeProperty('transition-timing-function');
                target.style.removeProperty('padding-top');
                target.style.removeProperty('padding-bottom');
                target.style.removeProperty('margin-top');
                target.style.removeProperty('margin-bottom');
                target.style.removeProperty('border-top-width');
                target.style.removeProperty('border-bottom-width');
                target.style.removeProperty('line-height');
                target.style.removeProperty('display');
                // trigger optional callback function
                cb();
            }, duration);
        }, 5);
    }, 5);
};

/**
 * slideToggle
 *
 * @param target
 * @param duration
 * @param easing
 * @param cb
 *
 * @description Toggle slide animation.
 *
 * @author Alexander Solbrig <aexl@dotdecay.com>
 * @since 1.0.0
 */
const slideToggle = (target, duration = 500, easing = 'ease', cb = () => {
}) => {
    if (window.getComputedStyle(target).display === 'none') {
        return slideDown(target, duration, easing, cb);
    } else {
        return slideUp(target, duration, easing, cb);
    }
};

export { show, hide, toggle, slideUp, slideDown, slideToggle };